"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M19 5H1c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 8h-8V7h8v6z"];
//# sourceMappingURL=segmented-control.js.map